import $ from "jquery";
import { failureToError, parametersToQuery } from "../../../search/api";
import { ADMIN_ENDPOINT } from "../api";

export function requestSearch(data, namespace, onSuccess, onError) {
	const query = parametersToQuery(data);

	return $.get(`${ADMIN_ENDPOINT}/${namespace}?${query}`)
		.done(onSuccess)
		.fail(failureToError(onError, "Search request failed"));
}
